<!--
================================================
Composant gérant le formulaire SignupData qui s'affichent juste après l'inscription
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="SignupDataComp">
        <div class="columns mainContainer">

            <div class="column is-three-fifths formColumn">

                <div class="columns">
                    <div class="column"></div>

                    <div class="column is-10 columnContForm">
                        <form action="" v-on:keyup.enter="validateBeforeSubmit">

                            <div class="step">{{$t('etape2sur2')}}</div>
                            <h1 class="is-size-4">{{ $t("AidezNousAAmeliorerVotreExperienceEnNousDisant") }}</h1>

                            <!-- CHAMPS SIZE ---->
                            <div class="field">
                                <div class="control">
                                  <label class="label has-text-left" for="">{{$t('combienDePersonnesTravaillentDansVotreOrganisation')}}</label>
                                  <div class="select is-medium is-fullwidth">
                                    <select v-model="organizationSize" id="signupData_org_size"
                                            v-validate="{ required: false, included: choices.size }"
                                            data-vv-validate-on="change"
                                            name="signupData_org_size"
                                    >
                                      <option v-for="(size) in choices.size"
                                              v-bind:key="size"
                                              v-bind:value="size">{{ size }}
                                      </option>


                                    </select>
                                  </div>

                                </div>
                                <p class="help is-danger has-text-left" id="error_signupData_org_size">{{errors.first('signupData_org_size') }}</p>
                            </div>


                          <!-- CHAMPS TYPE ---->
                          <div class="field">
                            <div class="control">
                              <label class="label has-text-left"
                                     for="">{{ $t('quelEstLeTypeDeVotreOrganisation') }}</label>
                              <div class="select is-medium is-fullwidth">
                                <select v-model="organizationType" id="signupData_org_type"
                                        v-validate="{ required: false, included: choices.type }"
                                        data-vv-validate-on="change"
                                        name="signupData_org_type"
                                ><option v-for="(type) in choices.type" v-bind:key="type" v-bind:value="type">
                                  {{ $t(type)}}</option>


                                </select>
                              </div>

                            </div>
                            <p class="help is-danger has-text-left" id="error_signupData_org_type">
                              {{ errors.first('signupData_org_type') }}</p>
                          </div>
                          <div class="field" v-if="organizationType=='other'">
                            <div class="control">
                              <input class="input" v-model="organizationTypeOther" v-validate="'min:2|max:128'"
                                     id="signupData_orgType_other" name="signupData_orgType_other" type="text"
                                     data-vv-delay="700"
                                     v-bind:placeholder="$t('letypeExactEst')">
                            </div>
                            <p class="help is-danger has-text-left" id="error_signupData_orgType_other">{{
                                errors.first('signupData_orgType_other')
                              }}</p>
                          </div>

                          <!-- CHAMPS POSITION ---->
                           <div class="field">
                            <div class="control">
                              <label class="label has-text-left"
                                     for="">{{ $t('quelEstVotreRole') }}</label>
                              <div class="select is-medium is-fullwidth">
                                <select v-model="position" id="signupData_position"
                                        v-validate="{ required: false, included: position }"
                                        data-vv-validate-on="change"
                                        name="signupData_position"
                                ><option v-for="(position) in choices.position" v-bind:key="position" v-bind:value="position">
                                  {{ $t(position)}}
                                </option>


                                </select>
                              </div>

                            </div>
                            <p class="help is-danger has-text-left" id="error_signupData_position">
                              {{ errors.first('signupData_position') }}</p>
                          </div>
                           <div class="field" v-if="position=='other'">
                              <div class="control">
                                <input class="input" v-model="positionOther" v-validate="'min:2|max:128'"
                                       id="signupData_position_other" name="signupData_position_other" type="text"
                                       data-vv-delay="700"
                                       v-bind:placeholder="$t('monRoleEst')">
                              </div>
                              <p class="help is-danger has-text-left" id="error_signupData_position_other">{{
                                  errors.first('signupData_position_other')
                                }}</p>
                            </div>


                          <!-- CHAMPS GOAL ---->
                          <div class="field">
                            <div class="control">
                              <label class="label has-text-left" for="">{{ $t('quelEstVotreBut') }}</label>
                              <div class="select is-medium is-fullwidth">
                                <select v-model="organizationGoal" id="signupData_org_goal"
                                        v-validate="{ required: false, included: organizationGoal }"
                                        data-vv-validate-on="change"
                                        name="signupData_org_goal"
                                ><option v-for="(goal) in choices.goal" v-bind:key="goal" v-bind:value="goal">
                                  {{ $t(goal)}}
                                </option>


                                </select>
                              </div>

                            </div>
                            <p class="help is-danger has-text-left" id="error_signupData_position">
                              {{ errors.first('signupData_position') }}</p>
                          </div>
                          <div class="field" v-if="organizationGoal=='other'">
                            <div class="control">
                              <input class="input" v-model="organizationGoalOther" v-validate="'min:2|max:128'"
                                     id="signupData_orgGoal_other" name="signupData_orgGoal_other" type="text"
                                     data-vv-delay="700"
                                     v-bind:placeholder="$t('monButEst')">
                            </div>
                            <p class="help is-danger has-text-left" id="error_signupData_orgGoal_other">{{
                                errors.first('signupData_orgGoal_other')
                              }}</p>
                          </div>


                            <div class="buttons">

                                <a v-on:click="validateBeforeSubmit" id="dataSignupSubmitBtn" v-bind:class="{'is-loading':isSubmiting}" class="button  submitBtn">{{$t("terminerMonInscription")}}</a>

                              <a
                                  v-on:click="
                                    $mixpanel.track('[DataSignup] skip button clicked');
                                    validateBeforeSubmit()
                                    ga4GlobalEventTrack('[DataSignup] skip button clicked', {})"
                                  id="skipFormLink" v-bind:class="{'is-loading':isSubmiting}" class=" skipFormLink is-link">{{$t("passer")}}</a>


                            </div>


                        </form>
                    </div>
                    <div class="column"></div>

                </div>


            </div>

            <div class="column is-two-fifths is-hidden-mobile infoColumn" id="infoColumn">

              <img src="../assets/img/AppLogo.png" alt="Cronocloud App" width="164" height="29" class="logo">

                <div class="columns">
                    <div class="column"></div>
                    <div class="column is-11"><img src="../assets/img/welcomeIllustration.png" alt="Cronocloud App"
                                                   width="300" class="illustration">

                        <div class="featList">

                            <h4>{{$t("pourquoiVousInscrire")}}</h4>
                            <ul class="">
                                <li> {{$t("simpleAUtiliser")}}</li>
                                <li> {{$t("fonctionneSurSmartphoneEtOrdinateurs")}}</li>
                                <li> {{$t("pasDInstallation")}}</li>
                                <li> {{$t("100%Gratuit")}}</li>
                            </ul>

                        </div>
                    </div>


                    <div class="column"></div>
                </div>


            </div>

        </div>

    </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import SentryMixin from "../mixins/SentryMixin.js";
    import InitialHydrationMixin from "../mixins/InitialHydrationMixin.js";
    import TimezoneMixin from "../mixins/TimezoneMixin.js";
    import TrackingMixin from "@/mixins/TrackingMixin";

    export default {
        name: 'SignupDataComp',
        components: {

        },
        mixins: [GlobalErrorNotification, SentryMixin, InitialHydrationMixin, TimezoneMixin, TrackingMixin],
        data: function () {
            return {

                userSlug: JSON.parse(this.$cookie.get('auth')).userSlug,
                organizationSlug : this.$route.params.organization,

              // champs du formulaire
                locale: this.$route.params.locale,      // {string} la locale récup. dans l'url
                isSubmiting: false ,     // indique si le formulaire est en cours de soumission

                organizationSize: '2-5', // string
                organizationType: null, // string
                organizationTypeOther:null, // string | org type suggested by user

                organizationGoal: null, // string
                organizationGoalOther:null, // string | org goal suggested by user

                position: null, // string (position of first user who sign up)
                positionOther: null, //string | position suggested by user

                choices: { // ATTENTION : À GARDER SYNCRO AVEC LA TRADUCTION DANS fr/en.json
                  size: ['1','2-5','6-10','11-25','26-50','51-200','201-1000','+1000'],
                  type: ['startup/saas','creative agency','solopreneur','freelance','other'],
                  position: ['project management','engineering','human resources','design','marketing','sales','accounting','support','other'],
                  goal: ['Suivre les temps de travail','Optimiser la rentabilité','Justifier des financières (crédit d\'impôt, J.E.I, etc.)','other']

                },
            }

        },

      computed: {
        ...mapState({
        }),
      },

        methods: {

            /*
            Envoi la requête pour réaliser l'inscription
            */
            sendSignupQuery(){

                // Si des champs "autre" ont été sélectionnés on envoit leurs valeurs
                let finalOrgType;
                this.organizationType==='other' ? finalOrgType=this.organizationTypeOther : finalOrgType = this.organizationType
                let finalPosition;
                this.position==='other' ? finalPosition=this.positionOther : finalPosition = this.position

                let finalGoal;
                this.organizationGoal==='other' ? finalGoal=this.organizationGoalOther : finalGoal = this.organizationGoal

                let self = this
                return self.$http
                    .post(`organizations/${self.organizationSlug}/signup/data/${self.userSlug}`, {
                      organizationSize: self.organizationSize,
                      organizationType: finalOrgType,
                      firstUserPosition:finalPosition,
                      organizationGoal:finalGoal
                    }, {
                      headers: {Authorization: self.$auth.header()},
                      timeout: 20000 // surcharge timeout car la requête a tendance à prendre du temps en dev @todo tempo à supr (si possible)

                        }
                    )

                    .then(function (response) {
                      self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                      // tracking
                      if(self.organizationType==='other') {
                          self.$mixpanel.track("[dataSignup] Other org. type selected")
                          self.ga4GlobalEventTrack('[dataSignup] Other org. type selected' , {})
                      }
                      if(self.position==='other' ){
                        self.$mixpanel.track("[dataSignup] other position selected")
                        self.ga4GlobalEventTrack('[dataSignup] other position selected' , {})
                      }
                      if(self.organizationGoal==='other'){
                        self.$mixpanel.track("[dataSignup] other goal selected")
                        self.ga4GlobalEventTrack('[dataSignup] other goal selected' , {})
                      }

                      self.$mixpanel.track("Data signup added",{"organizationSize":self.organizationSize,"organizationType":finalOrgType,"User position":self.finalPosition});
                      self.ga4GlobalEventTrack('Data signup added' , {})

                        // redirection
                        self.$router.replace({
                            name: 'timeTracking',
                            params: {
                                locale: self.$route.params.locale,
                                organization: self.organizationSlug
                            }
                        })

                    })
                    .catch(function (error) {
                        self.logToSentry(self, error, 'error')
                        let errorCode = '0047'
                        self.showGlobalErrorNotif(self,errorCode)
                        self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error in data signup query"})
                      self.$gtag.exception({'description': 'error '+errorCode + ' | error in data signup', 'fatal': false})

                      self.$sentry.captureMessage(`Error ${errorCode} > error in signup data query : ${error}`, 'error')
                    })
                    .then(() =>{
                        // toujours exécuté
                        this.isSubmiting = false;
                    })


            },

            /*
             * Valide le formulaire avant sa soumission
             */
            validateBeforeSubmit() {
                this.$store.commit('UpdateGlobalNotificationCompVisibility', false); // on masque un éventuel message à la soumission
                this.isSubmiting = true;

                let self = this
                this.$validator.validateAll().then((result) => {
                    if (result) { // si la validation. réussie
                        this.sendSignupQuery();
                    }
                    else{ // si il y a des erreurs...
                        self.$store.commit('UpdateGlobalNotificationComp', {
                            'isVisible': true,
                            'color': 'is-danger',
                            'message': self.$t('leFormulaireContientDesErreurs')
                        });
                        this.isSubmiting = false;
                    }

                })
            },



        },



        created: function () {

        },
        mounted: function () {

        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    @import "../assets/css/bulmaResponsiveDep.scss";


    .mainContainer {
        @include mobile {
            padding: 0 1.5rem;
            margin-top: -1.5rem;
        }
    }

    .formColumn {
        padding: 3rem 1rem;
        background: #f3f3f3;
        border-radius: 3px;

      .step{
        color: #999; font-weight: bold; font-size: 0.9rem;
      }
        h1 {
            margin: 2rem auto;
            color: $brandThird;
            font-size: 1.3rem !important;
            line-height: 1.8rem;
        }

        .field {
            margin-bottom: 2rem;
        }
        .buttons{
              margin: 4rem 0 0;
            .skipFormLink{color:#ccc; margin: 0 2rem; text-decoration: underline}
            .submitBtn {
            padding: 2rem ;
            border: solid 1px transparent;
            background: $brandPrimary;
            color: white;
            &:hover {
              transition: background-color 0.3s;
              background: lighten($brandPrimary, 5%);
              color: white;
            }
            &:active {
              background: $brandThird;
              transition: background-color 0.1s;
              color: white;
            }

          }
        }



        .columnContForm {
            @include mobile {
                padding: 0 2rem;
            }
        }

        .label{
          color:#666; font-size: 0.95rem;
        }
      select{ width: 100%; font-size: 1rem;
        padding: 0.7rem 1.5rem;
        height: auto}

    }

    .infoColumn {
        border-left: solid 1px #eee;
        padding: 3rem 1rem;
        background: #fff;
        border-top-right-radius: 25px;

        .logo {

        }

        .illustration {
            margin: 25% 0;
        }
        .featList {
            margin: 3rem 0;
            text-align: left;
            color: #a0a1a1;
            h4 {
                color: $brandThird;
                font-weight: bold
            }
            li {
                list-style: inside;
            }
        }

    }


</style>
